import { render, staticRenderFns } from "./CtrlProjectName.vue?vue&type=template&id=9c7a5078&scoped=true&"
import script from "./CtrlProjectName.vue?vue&type=script&lang=js&"
export * from "./CtrlProjectName.vue?vue&type=script&lang=js&"
import style0 from "./CtrlProjectName.vue?vue&type=style&index=0&id=9c7a5078&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c7a5078",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VRow,VToolbarTitle})
